import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=69e1b674&scoped=true&"
import script from "./ClientDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboard.vue?vue&type=style&index=0&id=69e1b674&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e1b674",
  null
  
)

export default component.exports